// Different surcharge types
const SURCHARGE_TYPES = Object.freeze({
    VAT: 1,
    STATE_TAX: 2,
    FEDERAL_TAX: 3,
    CITY_TAX: 4,
    DEPOSIT: 5,
    PLASTIC_TAX: 6,
    DEPOSIT_TAX: 7,
    UNKNOWN: 99,
});

// Different value types which define surcharge type like percentage or fixed price.
const VALUE_TYPE = Object.freeze({
    PERCENTAGE: 1,
    FIXED_VALUE: 2,
});

// This indicates how to apply the tax.
const APPLIED_ON = Object.freeze({
    BASE: 'base',
    ALL: 'all',
    NONE: 'none',
    ONLY_DEPOSIT: 'onlyDeposit',
});

module.exports = {
    SURCHARGE_TYPES,
    VALUE_TYPE,
    APPLIED_ON,
};
